import React from 'react';

import { Skeleton } from '@mui/material';
import { Base64 } from '../../../../../util/Base64';
import { useControlUnitById } from '../../../../../redux/controlUnit/hooks/useControlUnitById';
import useWatchError from '../../../../../handlingErrors/useWatchError';

interface ControlUnitTextProps {
  controlUnitId?: number;
  deviceId?: string;
}
function ControlUnitText(props: ControlUnitTextProps) {
  const { controlUnitId, deviceId = '' } = props;
  const {
    data: controlUnit,
    isLoading: isLoadingControlUnit,
    error: errorControlUnits,
  } = useControlUnitById(deviceId, controlUnitId + '');
  useWatchError(errorControlUnits);
  return (
    <>
      {isLoadingControlUnit ? (
        <Skeleton variant="rectangular" height={'1em'} width={'4em'} />
      ) : (
        controlUnit?.name.toLowerCase() ??
        controlUnitId?.toString().toLowerCase()
      )}
    </>
  );
}

export default ControlUnitText;
